import React, { createContext, useContext } from 'react';
import useAwsConfigHook from '../../../hooks/Dashboard/aws/useConfig';

export const AwsConfigContext = createContext();

export const AwsConfigProvider = ({ children }) => {
  const data = useAwsConfigHook();

  return (
    <AwsConfigContext.Provider value={data}>
      {children}
    </AwsConfigContext.Provider>
  );
};

export const useAwsConfig = () => useContext(AwsConfigContext);